import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VRadioGroup,{attrs:{"dense":"","row":"","disabled":_vm.disabled},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},_vm._l((_vm.items),function(opcao){return _c(VRadio,{key:opcao.key,attrs:{"label":`${opcao.name}`,"value":opcao.key}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }